var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };

var _react = require("react");

var _useOutboundClickListener = require("./utils/useOutboundClickListener");

var _useOutboundClickListener2 = _interopRequire(_useOutboundClickListener);

var _MatomoContext = require("./MatomoContext");

var _MatomoContext2 = _interopRequire(_MatomoContext);

function useMatomo() {
    var instance = (0, _react.useContext)(_MatomoContext2);
    var trackPageView = (0, _react.useCallback)(function (params) {
        return instance == null || instance == void 0 ? void 0 : instance.trackPageView(params);
    }, [instance]);
    var trackEvent = (0, _react.useCallback)(function (params) {
        return instance == null || instance == void 0 ? void 0 : instance.trackEvent(params);
    }, [instance]);
    var trackEvents = (0, _react.useCallback)(function () {
        return instance == null || instance == void 0 ? void 0 : instance.trackEvents();
    }, [instance]);
    var trackSiteSearch = (0, _react.useCallback)(function (params) {
        return instance == null || instance == void 0 ? void 0 : instance.trackSiteSearch(params);
    }, [instance]);
    var trackLink = (0, _react.useCallback)(function (params) {
        return instance == null || instance == void 0 ? void 0 : instance.trackLink(params);
    }, [instance]);
    var enableLinkTracking = (0, _react.useCallback)(function () {
        if (instance) {
            (0, _useOutboundClickListener2)(instance);
        }
    }, [instance]);
    var pushInstruction = (0, _react.useCallback)(function (name) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        instance == null || instance == void 0 ? void 0 : instance.pushInstruction.apply(instance, [name].concat(args));
    }, [instance]);
    return {
        trackEvent: trackEvent,
        trackEvents: trackEvents,
        trackPageView: trackPageView,
        trackSiteSearch: trackSiteSearch,
        trackLink: trackLink,
        enableLinkTracking: enableLinkTracking,
        pushInstruction: pushInstruction
    };
}
module.exports = useMatomo;
//# sourceMappingURL=useMatomo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js
// module id = 772
// module chunks = 0